import { Component, OnInit } from '@angular/core';
import {Route,Router, ActivatedRoute} from '@angular/router';
import * as firebase from "firebase/app";

// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/database";

@Component({
  selector: 'app-listfaculties',
  templateUrl: './listfaculties.component.html',
  styleUrls: ['./listfaculties.component.css']
})
export class ListfacultiesComponent implements OnInit {
y:any;
dataarray:any[] = [];
  constructor(private route: ActivatedRoute, private router:Router) {
   }

  ngOnInit() {
    this.y = this.route.snapshot.data['listfaculties'];
    let namesarray = Object.keys(this.y);
     namesarray.forEach((name)=>{
       this.dataarray.push(this.y[name]);
       console.log(this.dataarray);
     });

  }
editnavigate(name) {
  console.log(name);
}
delete(name){
  let db =  firebase.database();
  db.ref('faculties/'+name).set(null, function(error){
    if(error){
      alert(error)
    }else{
      alert("You have successfully deleted "+name+" department");
      this.router.navigate(['/admin', 'listfaculties'])
    }
  })
}
}
